import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { DollarSign } from 'lucide-react';

const ReferralsTab = ({ settings, setSettings }) => (
  <Card>
    <CardHeader><CardTitle>Referral Incentive Program</CardTitle><CardDescription>Configure employee referral rewards</CardDescription></CardHeader>
    <CardContent className="space-y-6">
      <div className="flex items-center justify-between p-4 bg-[#F5F5F5] rounded-lg">
        <div className="flex items-center gap-3">
          <DollarSign className="h-5 w-5 text-[#4B2D6E]" />
          <div><p className="font-medium">Enable Referral Incentives</p><p className="text-sm text-[#666666]">Reward employees for successful referrals</p></div>
        </div>
        <Switch checked={settings?.referral_incentive_enabled} onCheckedChange={(checked) => setSettings({ ...settings, referral_incentive_enabled: checked })} data-testid="referral-enabled-switch" />
      </div>
      {settings?.referral_incentive_enabled && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="incentive_amount">Incentive Amount ($)</Label>
            <Input id="incentive_amount" type="number" value={settings?.referral_incentive_amount || 100} onChange={(e) => setSettings({ ...settings, referral_incentive_amount: parseInt(e.target.value) })} data-testid="incentive-amount-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="incentive_trigger">Trigger Event</Label>
            <Select value={settings?.referral_incentive_trigger || 'hired'} onValueChange={(value) => setSettings({ ...settings, referral_incentive_trigger: value })}>
              <SelectTrigger data-testid="incentive-trigger-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="interview_completed">Interview Completed</SelectItem>
                <SelectItem value="hired">Hired</SelectItem>
                <SelectItem value="30_days">30 Days Employed</SelectItem>
                <SelectItem value="60_days">60 Days Employed</SelectItem>
                <SelectItem value="90_days">90 Days Employed</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);

export { ReferralsTab };
